import { Stack } from "@mui/material";
import { Switch } from "features/shared/components/Switch";

import { ScenarioFieldRow } from "./ScenarioFieldRow";

type ConfigurationSwitchRowProps = {
  alignControl?: boolean;
  checked: boolean;
  label: string;
  labelClassName?: string;
  onChange: (checked: boolean) => void;
};

export const ConfigurationSwitchRow = ({
  alignControl = false,
  checked,
  label,
  labelClassName,
  onChange,
}: ConfigurationSwitchRowProps) => {
  if (alignControl) {
    return (
      <ScenarioFieldRow alignControlEnd label={label} labelClassName={labelClassName}>
        <Stack className="w-full justify-end">
          <Switch checked={checked} onChange={onChange} size="small" />
        </Stack>
      </ScenarioFieldRow>
    );
  }
  return (
    <Stack className="h-10 w-full justify-between gap-ds-0-75x">
      <span className="flex-1 truncate text-lds-foreground-primary font-ds-body-semibold-sm">{label}</span>
      <Switch checked={checked} onChange={onChange} size="small" />
    </Stack>
  );
};
